
export interface EventRecord {
    id: number;
    provider: EventRecordProvider;
    providerUrl: string;
    bibImageUrl?: string;
    runEventDistanceId?: number;
}

export interface UpsertEventRecord {
    id?: number;
    provider?: EventRecordProvider;
    providerUrl?: string;
    bibImageUrl?: string;
    runEventDistanceId?: number; 
}

export enum EventRecordProvider
{
    Sporthive = 1,
    CheckPointSpot = 2
}
export const EventRecordProviderList = [
    {value: 1, label: "Sporthive"},
    {value: 2, label: "Check Point Spot"},
];